import { CSSProperties } from 'react'

const styles: { action: CSSProperties } = {
  action: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    borderRadius: 6,
  },
}

export default styles
